(function () {
  'use strict';
  if (window.SMSAigCartValidation) return;
  var initial = document.querySelector('[data-aig-cart-state]');
  if (!initial) return;
  var data = JSON.parse(initial.textContent);
  var mode = 'checking';
  var invalid = [];
  var hasWarranty = false;
  var activeMutations = 0;
  var generation = 0;
  var refreshing = null;
  var timer;
  var replay = false;
  var controls = new Map();
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var fetchCartState = window.fetch.bind(window);
  var checkoutSelector = 'button[name="checkout"],input[name="checkout"],.rebuy-cart__checkout-button,.cart__checkout-button,a[href*="/checkout"]';
  var expressSelector = '.cart__dynamic-checkout-buttons,.additional-checkout-buttons,.rebuy-cart__accelerated-checkout-buttons,.rebuy-cart__shop-pay-button,.shopify-payment-button,shopify-accelerated-checkout,shopify-accelerated-checkout-cart';

  var offerBusy = false;
  var offerError = '';
  var offerSelections = new Map();
  var cartOffersOpen = false;
  // Temporarily disabled by request. Set to true to restore the full cart-page dropdown.
  var cartWarrantyOffersEnabled = false;
  function getWarrantyRows(state) {
    return state.items.filter(function (item) {
      return !item.isWarranty && item.quantity > 0 && item.options && item.options.length;
    }).map(function (item) {
      return {
        item: item,
        warranties: state.items.filter(function (line) {
          return line.isWarranty && line.quantity > 0 && line.eligible.some(function (product) {
            return String(product.id) === String(item.productId);
          });
        })
      };
    });
  }
  function getOffers(state) {
    return getWarrantyRows(state).filter(function (row) {
      return !row.warranties.length;
    }).map(function (row) { return row.item; });
  }
  async function addOffer(key, variantId) {
    if (offerBusy || !variantId) return;
    offerBusy = true;
    offerError = '';
    renderOffers();
    try {
      await refresh();
      if (mode === 'checking' || mode === 'error' || activeMutations) throw new Error(data.offer.failed);
      var item = getOffers(data).find(function (line) { return line.key === key; });
      if (!item) return;
      var option = item.options.find(function (plan) { return String(plan.variantId) === String(variantId) && plan.available; });
      if (!option) throw new Error(data.offer.failed);
      var response = await window.fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: option.variantId, quantity: item.quantity, properties: {
          _aig_equipment_variant_id: item.variantId,
          _aig_group: item.group || ('aig-' + item.variantId + '-' + Date.now())
        } }] })
      });
      var result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || data.offer.failed);
      await refresh();
      if (window.SMSRebuyCart && typeof window.SMSRebuyCart.open === 'function') {
        await window.SMSRebuyCart.open({ fallback: false });
      }
      if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
    } catch (error) {
      offerError = error.message || data.offer.failed;
    } finally {
      offerBusy = false;
      await refresh();
      renderOffers();
    }
  }
  function renderOffers() {
    document.querySelectorAll('[data-aig-cart-offers]').forEach(function (box) {
      if (box.tagName === 'DETAILS') cartOffersOpen = box.open;
      box.remove();
    });
    if (!data.offer || mode === 'checking' || mode === 'error') return;
    var cartRows = getWarrantyRows(data);
    var offers = getOffers(data);
    if (!cartRows.length && !offers.length) return;
    document.querySelectorAll('.rebuy-cart__footer,.cart__footer,.drawer__footer').forEach(function (host) {
      if (!cartWarrantyOffersEnabled && host.matches('.cart__footer')) return;
      var cartHost = host.querySelector('[data-cart-warranties-slot]');
      var rows = cartHost ? cartRows : offers.map(function (item) {
        return { item: item, warranties: [] };
      });
      if (!rows.length) return;
      var box = document.createElement(cartHost ? 'details' : 'section');
      box.setAttribute('data-aig-cart-offers', '');
      box.className = 'aig-cart-offers';
      if (cartHost) {
        box.open = cartOffersOpen;
        var summary = document.createElement('summary');
        summary.textContent = data.offer.dropdownHeading;
        box.appendChild(summary);
        box.addEventListener('toggle', function () {
          if (box.isConnected) cartOffersOpen = box.open;
        });
      }
      var content = document.createElement('div');
      content.className = 'aig-cart-offers__content';
      box.appendChild(content);
      var heading = document.createElement('h3');
      heading.textContent = cartHost ? data.offer.providerHeading : data.offer.heading;
      content.appendChild(heading);
      var note = document.createElement('p');
      note.textContent = data.offer.optional;
      content.appendChild(note);
      rows.forEach(function (warrantyRow) {
        var item = warrantyRow.item;
        var row = document.createElement('div');
        var label = document.createElement('label');
        label.textContent = item.title;
        row.appendChild(label);
        if (warrantyRow.warranties.length) {
          var added = document.createElement('p');
          added.className = 'aig-cart-offers__added';
          added.textContent = data.offer.inCart.replace('[warranty]', warrantyRow.warranties.map(function (line) {
            return line.title;
          }).join(', '));
          row.appendChild(added);
          content.appendChild(row);
          return;
        }
        var select = document.createElement('select');
        select.setAttribute('aria-label', data.offer.choose + ': ' + item.title);
        var none = document.createElement('option');
        none.value = '';
        none.textContent = data.offer.choose;
        select.appendChild(none);
        item.options.forEach(function (plan) {
          var option = document.createElement('option');
          option.value = plan.variantId;
          option.textContent = plan.title + ' — ' + plan.price + (plan.available ? '' : ' — ' + data.offer.unavailable);
          option.disabled = !plan.available;
          select.appendChild(option);
        });
        select.value = offerSelections.get(item.key) || '';
        select.disabled = offerBusy;
        label.appendChild(select);
        var quantity = document.createElement('p');
        quantity.textContent = data.offer.quantity.replace('[quantity]', item.quantity);
        row.appendChild(quantity);
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'button';
        button.textContent = offerBusy ? data.offer.adding : data.offer.add;
        button.disabled = offerBusy || !select.value;
        select.addEventListener('change', function () {
          offerSelections.set(item.key, select.value);
          button.disabled = offerBusy || !select.value;
        });
        button.addEventListener('click', function () { addOffer(item.key, select.value); });
        row.appendChild(button);
        content.appendChild(row);
      });
      var florida = document.createElement('p');
      florida.textContent = data.offer.florida;
      content.appendChild(florida);
      if (offerError) {
        var error = document.createElement('p');
        error.setAttribute('role', 'alert');
        error.textContent = offerError;
        content.appendChild(error);
      }
      (cartHost || host).prepend(box);
    });
  }

  function evaluate(state) {
    var present = new Set(state.items.filter(function (item) {
      return item.quantity > 0 && !item.isWarranty;
    }).map(function (item) { return String(item.productId); }));
    return state.items.filter(function (item) {
      return item.quantity > 0 && item.isWarranty && !item.eligible.some(function (product) {
        return present.has(String(product.id));
      });
    });
  }

  function setData(state) {
    if (!state || !Array.isArray(state.items) || state.items.some(function (item) {
      return !Array.isArray(item.eligible) || typeof item.isWarranty !== 'boolean';
    })) throw new Error('Invalid cart validation response');
    data = state;
    invalid = evaluate(state);
    hasWarranty = state.items.some(function (item) { return item.isWarranty && item.quantity > 0; });
    mode = invalid.length ? 'invalid' : 'valid';
    render();
  }

  function makeMessage() {
    var box = document.createElement('div');
    box.className = 'aig-cart-validation-message';
    box.setAttribute('data-aig-validation-message', '');
    box.setAttribute('role', 'status');
    box.setAttribute('aria-live', 'polite');
    if (mode === 'invalid') {
      invalid.forEach(function (item) {
        var title = document.createElement('strong');
        title.textContent = item.title;
        box.appendChild(title);
        var message = document.createElement('p');
        message.textContent = data.message;
        box.appendChild(message);
        if (item.eligible.length) {
          var heading = document.createElement('strong');
          heading.textContent = data.eligibleHeading;
          box.appendChild(heading);
          var list = document.createElement('ul');
          item.eligible.forEach(function (product) {
            var row = document.createElement('li');
            var link = document.createElement('a');
            link.textContent = product.title;
            var url = new URL(product.url, window.location.origin);
            if (url.origin === window.location.origin) link.href = url.href;
            row.appendChild(link);
            list.appendChild(row);
          });
          box.appendChild(list);
        }
      });
    } else {
      box.textContent = mode === 'error' ? data.unavailable : data.checking;
      if (mode === 'error') {
        var retry = document.createElement('button');
        retry.type = 'button';
        retry.textContent = data.retry;
        retry.addEventListener('click', refresh);
        box.appendChild(retry);
      }
    }
    return box;
  }

  var lastMessageSignature = '';
  function render() {
    var blocked = mode !== 'valid';
    document.documentElement.classList.toggle('aig-checkout-blocked', blocked);
    document.documentElement.classList.toggle('aig-cart-has-warranty', hasWarranty);
    document.querySelectorAll(checkoutSelector).forEach(function (button) {
      if (blocked) {
        if (!controls.has(button)) controls.set(button, {
          disabled: button.disabled, aria: button.getAttribute('aria-disabled')
        });
        if ('disabled' in button) button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      }
    });
    if (!blocked) {
      controls.forEach(function (saved, button) {
        if ('disabled' in button) button.disabled = saved.disabled;
        if (saved.aria === null) button.removeAttribute('aria-disabled');
        else button.setAttribute('aria-disabled', saved.aria);
      });
      controls.clear();
    }
    renderOffers();
    var signature = JSON.stringify([mode, invalid]);
    if (signature !== lastMessageSignature || !blocked) {
      document.querySelectorAll('[data-aig-validation-message]').forEach(function (box) { box.remove(); });
      lastMessageSignature = signature;
    }
    if (mode === 'invalid' || mode === 'error') {
      document.querySelectorAll('.rebuy-cart__footer,.cart__footer,.drawer__footer').forEach(function (host) {
        if (!host.querySelector('[data-aig-validation-message]')) host.prepend(makeMessage());
      });
    }
  }

  async function refresh() {
    if (refreshing) return refreshing;
    if (activeMutations) return false;
    mode = 'checking';
    render();
    refreshing = (async function () {
      try {
        var version;
        do {
          version = generation;
          var response = await fetchCartState(root + 'cart?section_id=aig-cart-validation&_aig=' + Date.now(), {
            credentials: 'same-origin', cache: 'no-store'
          });
          if (!response.ok) throw new Error('Cart validation unavailable');
          var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          var state = doc.querySelector('[data-aig-cart-state]');
          if (!state) throw new Error('Cart validation data missing');
          if (activeMutations) return false;
          if (version === generation) setData(JSON.parse(state.textContent));
        } while (version !== generation);
        return mode === 'valid';
      } catch (error) {
        mode = 'error';
        render();
        return false;
      } finally {
        refreshing = null;
      }
    }());
    return refreshing;
  }

  function schedule() {
    generation += 1;
    mode = 'checking';
    render();
    clearTimeout(timer);
    timer = setTimeout(refresh, 80);
  }

  function isCartMutation(value, method) {
    try {
      var url = new URL(value, window.location.origin);
      return url.origin === window.location.origin && method.toUpperCase() !== 'GET' && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
    } catch (error) { return false; }
  }

  function startMutation() { activeMutations += 1; schedule(); }
  function endMutation() { activeMutations = Math.max(0, activeMutations - 1); schedule(); }
  var previousFetch = window.fetch;
  window.fetch = function (input, options) {
    var url = typeof input === 'string' || input instanceof URL ? String(input) : input.url;
    var method = (options && options.method) || (input && input.method) || 'GET';
    if (!isCartMutation(url, method)) return previousFetch.apply(this, arguments);
    startMutation();
    try { return Promise.resolve(previousFetch.apply(this, arguments)).finally(endMutation); }
    catch (error) { endMutation(); throw error; }
  };
  var open = XMLHttpRequest.prototype.open;
  var send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.aigCartMutation = isCartMutation(url, method);
    return open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (!this.aigCartMutation) return send.apply(this, arguments);
    startMutation();
    this.addEventListener('loadend', endMutation, { once: true });
    try { return send.apply(this, arguments); }
    catch (error) { this.removeEventListener('loadend', endMutation); endMutation(); throw error; }
  };

  async function intercept(event, target, resume) {
    if (replay) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (activeMutations) return;
    if (await refresh()) {
      if (activeMutations || mode !== 'valid') return;
      replay = true;
      try { resume(); } finally { replay = false; }
    } else {
      var message = document.querySelector('.rebuy-cart.is-visible [data-aig-validation-message],.cart__footer [data-aig-validation-message]');
      if (message) message.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }
  window.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest(checkoutSelector);
    if (!target) return;
    intercept(event, target, function () { target.click(); });
  }, true);
  window.addEventListener('submit', function (event) {
    var form = event.target;
    var action = new URL(form.action || window.location.href, window.location.origin);
    var checkout = /\/checkout\/?$/.test(action.pathname) || (event.submitter && event.submitter.name === 'checkout');
    if (!checkout) return;
    intercept(event, form, function () { form.requestSubmit(event.submitter || undefined); });
  }, true);
  ['rebuy:cart.ready', 'rebuy:cart.add', 'rebuy:cart.change', 'rebuy:cart.enriched', 'rebuy:smartcart.show', 'cart:updated', 'cart:change'].forEach(function (name) {
    document.addEventListener(name, schedule);
  });
  window.addEventListener('pageshow', schedule);
  window.addEventListener('focus', schedule);
  new MutationObserver(function (records) {
    if (records.some(function (record) {
      return Array.from(record.addedNodes).some(function (node) {
        return node.nodeType === 1 && !node.matches('[data-aig-validation-message]') &&
          (node.matches(checkoutSelector + ',.rebuy-cart__footer,.cart__footer,.drawer__footer') || node.querySelector(checkoutSelector));
      });
    })) render();
  }).observe(document.body, { childList: true, subtree: true });
  window.SMSAigCartValidation = { refresh: refresh, evaluate: evaluate, getOffers: getOffers, getWarrantyRows: getWarrantyRows };
  setData(data);
  schedule();
}());
